jQuery(function ($) {

  $('.bundled_product_image').magnificPopup({
    delegate: 'a',
    type: 'image',
    gallery: {
        enabled: true,
        tCounter: '%curr% / %total%'
    },
    image: {
        titleSrc: 'title'
        // this tells the script which attribute has your caption
    }
  });

  // Enable Magnific Popup for gallery
    $('.gallery').each(function() {
        $(this).magnificPopup({
            delegate: 'a',
            type: 'image',
            gallery: {
                enabled: true,
                tCounter: '%curr% / %total%'
            },
            image: {
                titleSrc: 'title'
                // this tells the script which attribute has your caption
            }
        });
    });

    // Enable Magnific Popup for WooCommerce
    $('.woocommerce-product-gallery__wrapper').each(function() {
        $(this).magnificPopup({
            delegate: 'a',
            type: 'image',
            gallery: {
                enabled: true,
                tCounter: '%curr% / %total%'
            },
            image: {
                titleSrc: 'title'
                // this tells the script which attribute has your caption
            }
        });
    });

    /*
    $('#acf-field_5fb4e49741bb2').prop('readonly', true);
    $('#acf-field_5fb4e4dc41bb3').prop('readonly', true);
    $('#acf-field_5fc63747a337b').prop('readonly', true);
    */

    $('.nav-collapse ul li .sub-menu-wrap').each(function() {
        var parent_id = $( this ).parent().attr('id');
        $('.megamenu-container').append('<div id="sub-' + parent_id + '" class="sub-menu-container">' + $( this ).html() + '<hr class="clear" /></div>')
    });

    $('.nav-collapse ul li').hover(function() {

        var elem_name = '#sub-' + $(this).attr('id');

        if ($(window).width() > (991 - 15)) {
              $( elem_name ).delay(800).show(0);
        }

    }, function() {

        var elem_name = '#sub-' + $( this ).attr('id');

        $( elem_name ).hide(0);

    });

    $('.megamenu-container .sub-menu-container').hover(function() {

        if ($(window).width() > (991 - 15)) {
            $( this ).show();
        }

    }, function() {

        $( this ).hide();

    });

$('.megamenu-container .sub-menu .sub-menu').parent().parent().addClass('toka');

$('.nav-secondary .sub-menu').prev().addClass('parent');
$('.nav-secondary li').not(".parent").addClass('alone');
$('.nav-secondary .parent').prepend('<div class="cat-icon"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 5V19" stroke="#04A64B" stroke-width="2" stroke-linejoin="round"/><path d="M5 12H19" stroke="#04A64B" stroke-width="2" stroke-linejoin="round"/></svg></div>');
$('.level-2.active').parent().prev().addClass('active');
$('.active .cat-icon').addClass('rotateicon');

$('.cat-icon').on('click', function(){
  $(this).toggleClass('rotateicon');
  $(this).parent().next().slideToggle();
});

$('.current-cat .cat-icon').addClass('rotateicon');
$('.current-cat-parent .cat-icon').addClass('rotateicon');

});

// jQuery(function ($) {
//   $(document).ready(function($){
//     $('.product-type-variable .bundle_wrap').append('<div class="total-price"></div>');
//     var price = $('.total-price');
//     var bundleprice = 0;
//     var parsePrice = 0;
//     var total = 0;

//     $('.variations_form').on('change', function(){
//       parsePrice = parseFloat($('.woocommerce-variation bdi').text().replace('€',''));
//       total += bundleprice;
//       price.text(total);
//     });

//     $('.bundled_product_checkbox').on('change', function(){
//       if($(this).checked) {
//         bundleprice = parseFloat($(this).next().find('bdi').text().replace('€',''));
//         total += bundleprice;
//       }
//       price.text(total);
//     });
//   });
// });

function docReady(fn) {
  // see if DOM is already available
  if (document.readyState === "complete" || document.readyState === "interactive") {
    // call on next available tick
    setTimeout(fn, 1);
  } else {
    document.addEventListener("DOMContentLoaded", fn);
  }
}

docReady(function() {
  var btn = document.querySelector('#show-products');
  var extra = document.querySelector('#show-extra-products');
  if(btn){
    btn.addEventListener("click", function() {
      var items = document.getElementsByClassName('bundled_product');
      for (var i = 0; i < items.length; i++) {
        items[i].classList.toggle('show');
      }
    });
  }
  if(extra){
    extra.addEventListener("click", function() {
      var items = document.querySelector('.bundle_sells_form');
        items.classList.toggle('show');
    });
  }

  (function() {
    ('a').click(function(e) {
         var lnkHref = $(this).attr('href');
         if (lnkHref.substr(lnkHref.length - 1) == '#')
         {
             e.preventDefault();
         }
    });
 })
});
